@if (bookingService?.selectedBookingData?.totalBookingAmount > 0) {
  <div class="mb-1" role="region" [attr.aria-label]="'Payment method selection'">
    <app-csw-text
      [text]="((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.PAYMENT_CARD_TITLE, type: 'template' }) | translation: 'template_content': lang)"
      customClass="fw-600"
      role="heading"
      aria-level="2"
    />
  </div>
  <div class="mb-2" role="radiogroup" [attr.aria-label]="'Select payment method'">
    @if (isServiceOnlinePaymentEnabled && isStripeEnabled) {
      <div class="d-flex align-items-center mt-1 radio-item">
        <input type="radio" class="payment-type-radio-button" [disabled]="paymentLocked" [value]="paymentMethods.CREDITCARD"
          id="creditcard"
          (change)="onPaymentTypeChange(paymentMethods.CREDITCARD)"
          [(ngModel)]="paymentType" name="paymentType"
          [checked]="paymentType === paymentMethods.CREDITCARD ? true: false"
          [attr.aria-label]="'Credit card payment'"
        >
        <label class="radio-button-label mb-0" for="creditcard">
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_CREDIT_CARD_LABEL, type: 'template' }) | translation: 'template_content': lang) }}
        </label>
      </div>
    }
    @if (isBexioEnabled) {
      <div class="d-flex align-items-center mt-1 radio-item">
        <input type="radio" class="payment-type-radio-button" [disabled]="paymentLocked" [value]="paymentMethods.INVOICE" id="invoice"
          (change)="onPaymentTypeChange(paymentMethods.INVOICE)"
          [(ngModel)]="paymentType" name="paymentType"
          [checked]="paymentType === paymentMethods.INVOICE ? true: false"
        >
        <label class="radio-button-label mb-0" for="invoice">{{ 'payment_method.invoice' | translate }}</label>
      </div>
    }
    @if (isServiceOnlinePaymentEnabled && isPaypalEnabled) {
      <div class="d-flex align-items-center mt-1 radio-item">
        <input type="radio" class="payment-type-radio-button" [disabled]="paymentLocked" [value]="paymentMethods.PAYPAL"
          id="paypal-radio-btn"
          (change)="onPaymentTypeChange(paymentMethods.PAYPAL)" [(ngModel)]="paymentType" name="paymentType"
          [checked]="paymentType === paymentMethods.PAYPAL ? true: false"
        >
        <label class="radio-button-label mb-0" for="paypal-radio-btn">{{ 'payment_method.paypal' | translate }}</label>
      </div>
    }
    @if (isServiceOnlinePaymentEnabled && isAdyenSelectable) {
      <div class="d-flex align-items-center mt-1 radio-item">
        <input type="radio" class="payment-type-radio-button" [disabled]="paymentLocked" [value]="paymentMethods.ADYEN"
          id="adyen-radio-btn"
          (change)="onPaymentTypeChange(paymentMethods.ADYEN)" [(ngModel)]="paymentType" name="paymentType"
          [checked]="paymentType === paymentMethods.ADYEN ? true: false"
        >
        <label class="radio-button-label mb-0" for="adyen-radio-btn">{{ 'adyen.payment_method_label' | translate }}</label>
      </div>
    }
    @if (isStoreEnabled) {
      <div class="d-flex align-items-center mt-1 radio-item">
        <input type="radio" class="payment-type-radio-button" [disabled]="paymentLocked" [value]="paymentMethods.STORE" id="store"
          (change)="onPaymentTypeChange(paymentMethods.STORE)" [(ngModel)]="paymentType" name="paymentType"
          [checked]="paymentType === paymentMethods.STORE ? true: false"
        >
        <label class="radio-button-label mb-0" for="store">
          {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_IN_STORE_LABEL, type: 'template' }) | translation: 'template_content': lang) }}
        </label>
      </div>
    }
    @if (isLexOfficePaymentTypeEnabled) {
      <div class="d-flex align-items-center mt-1 radio-item">
        <input type="radio" class="payment-type-radio-button" [disabled]="paymentLocked" [value]="paymentMethods.LEX_OFFICE_INVOICE" id="lexoffice-radio-btn"
          (change)="onPaymentTypeChange(paymentMethods.LEX_OFFICE_INVOICE)" [(ngModel)]="paymentType" name="paymentType"
          [checked]="paymentType === paymentMethods.LEX_OFFICE_INVOICE ? true : false"
        >
        <label class="radio-button-label mb-0" for="lexoffice-radio-btn">{{ 'payment_method.lexoffice' | translate }}</label>
      </div>
    }
    @if (isExternalInvoiceEnabled) {
      <div class="d-flex align-items-center mt-1 radio-item">
        <input type="radio" class="payment-type-radio-button" [disabled]="paymentLocked" [value]="paymentMethods.EXTERNAL_INVOICE" id="external-invoice-radio-btn"
          (change)="onPaymentTypeChange(paymentMethods.EXTERNAL_INVOICE)" [(ngModel)]="paymentType" name="paymentType"
          [checked]="paymentType === paymentMethods.EXTERNAL_INVOICE ? true : false"
        >
        <label class="radio-button-label mb-0" for="external-invoice-radio-btn">{{ 'payment_method.external_invoice' | translate }}</label>
      </div>
    }
  </div>
  @if (!paymentLocked) {
  <div class="mb-2">
    <app-csw-link
      [styleConfig]="{
        'color': widgetService?.widgetConf?.header_background_color,
        'textDecorationColor': widgetService?.widgetConf?.header_background_color
      }"
      [showUnderLine]="true"
      [isLink]="false"
      [text]="((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_DISCOUNT_CODE_APPLY_TEXT, type: 'template' }) | translation: 'template_content': lang)"
      (clickEvent)="toggleCoupon()"
      role="button"
      [attr.aria-label]="'Redeem coupon code'"
      tabindex="0"
    />
  </div>
  }
  @if (showCouponField && !paymentLocked) {
    <div class="d-flex flex-column align-items-start cw-stripe-box mb-2" role="region" [attr.aria-label]="'Coupon code section'">
      <div class="stripe-title" role="heading" aria-level="3">
        {{ (bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_APPLY_COUPON_BUTTON, type: 'template' }) | translation: 'template_content': lang }}:
      </div>
      <div class="stripe-field mt-2 w-100">
        <app-coupon-form />
      </div>
    </div>
  }
  @if (isExternalInvoiceEnabled && paymentType === paymentMethods.EXTERNAL_INVOICE) {
    <div class="d-flex flex-column align-items-start cw-stripe-box mb-2" role="region" [attr.aria-label]="'Invoice address section'">
      <div class="stripe-field w-100">
        <app-invoice-address-form
          [isAddressMandatory]="isInvoiceAddressMandatory"
          [lang]="lang"
          [defaultCountryCode]="partnerCountryCode"
          [prefill]="invoicePrefill"
          (invoiceAddressChangeEvent)="onInvoiceAddressChange($event)"
        />
      </div>
    </div>
  }
  @if (
    isStripeEnabled
    && paymentType === paymentMethods.CREDITCARD
    && bookingService?.selectedBookingData?.totalBookingAmount > 0
  ) {
    <div class="d-flex flex-column align-items-start cw-stripe-box mb-2" role="region" [attr.aria-label]="'Credit card payment section'">
      <div class="stripe-title" role="heading" aria-level="3">
        {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_CREDIT_CARD_LABEL, type: 'template' }) | translation: 'template_content': lang) }}:
      </div>
      <div class="stripe-field mt-1 w-100">
        <app-stripe
          [connectedAccountId]="stripeConnectedAccountId"
          [coupon]="coupon"
          [finalCouponDiscount]="finalCouponDiscount"
          [originalAmount]="originalAmount"
          [priceAfterCouponReduction]="priceAfterCouponReduction"
          [storageComplete]="storageComplete"
        />
      </div>
    </div>
  }
  @if (
    isPaypalEnabled
    && paymentType === paymentMethods.PAYPAL
    && bookingService?.selectedBookingData?.totalBookingAmount > 0
    && !bookingService?.selectedBookingData?.paymentMethodData?.paypalOrderDetail
  ) {
    <!-- Once a capture exists (paypalOrderDetail set), remove the PayPal buttons so a second
         popup (a second CAPTURE for the same appointment) cannot be started while the booking is
         in flight. A cancelled/failed attempt clears the detail, so the buttons come back for a
         retry. Keyed on the capture itself - NOT on disableAllButton, which is now also set while
         the popup is open (the Stripe-style attempt freeze) and must not tear zoid down mid-payment. -->
    <div class="cw-paypal-box mt-4" role="region" [attr.aria-label]="'PayPal payment section'">
      @if (showPaypalLoader) {
        <div role="status" [attr.aria-label]="'Loading PayPal'">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <div class="spinner-border" role="status" aria-hidden="true">
              <span class="visually-hidden">Loading PayPal...</span>
            </div>
            <div class="mt-2">
              Resetting Paypal
            </div>
          </div>
        </div>
      }
      @if (!showPaypalLoader) {
        <app-cw-paypal
          [paypalSetting]="paypalSetting"
          [price]="bookingService?.selectedBookingData?.totalBookingAmount"
          [discount]="bookingService?.selectedBookingData?.totalDiscount"
        />
      }
    </div>
  }
  @if (
    isAdyenSelectable
    && paymentType === paymentMethods.ADYEN
    && bookingService?.selectedBookingData?.totalBookingAmount > 0
  ) {
    <div class="mt-4" role="region" [attr.aria-label]="'Adyen payment section'">
      <app-cw-adyen
        [price]="bookingService?.selectedBookingData?.totalBookingAmount"
      />
    </div>
  }
}
@if (
  bookingService.partnerData?.is_captcha_feature_enabled &&
  bookingService.partnerData?.captcha_type === captchaType.CALENSO_DEFAULT &&
  bookingService.selectedBookingData?.captcha
) {
  <div class="mb-2" role="region" [attr.aria-label]="'Security verification'">
    <label class="input-label cbw-captcha-label" for="captcha">
      <span [innerHTML]="((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_CAPTCHA_TEXT, type: 'template' }) | translation: 'template_content': lang | addRequired) | calioSafe: 'html'"></span>
    </label>
    <div>
      <img [src]="'data:image/png;base64,' + bookingService.selectedBookingData.captcha.captcha" alt="Security verification code" class="captcha-img cbw-captcha-img" />
    </div>
    <div class="pt-3 captcha-input-width">
      <div class="d-flex align-items-center justify-content-center gap-2">
        <input
          id="captcha"
          type="text"
          required
          name="captcha"
          #captcha="ngModel"
          placeholder="{{ 'captcha.placeholder' | translate }}"
          maxlength="6"
          minlength="6"
          spellcheck="false"
          [(ngModel)]="captchaInput"
          class="form-control cbw-input-field cbw-input-captcha-field"
          [attr.aria-invalid]="captcha.touched && !captcha?.valid"
          [attr.aria-describedby]="captcha.touched ? (captcha?.valid ? 'captcha-success' : 'captcha-error') : null"
        >
        @if (validatingCaptchaChallenge) {
          <div class="d-inline-flex" role="status" aria-hidden="true">
            <mat-icon class="spin-animation" svgIcon="calio-spinner-icon" />
          </div>
        }
      </div>
      @if (captcha.touched && !captcha?.valid) {
        <div id="captcha-error" class="alert alert-danger captcha-warning cbw-captcha-error default-captcha-error" role="alert">
          @if (captcha.errors?.required) {
            {{ 'captcha.required' | translate }}
          } @else if (captcha.errors?.minlength) {
            {{ 'captcha.invalid' | translate }}
          } @else if (captcha.errors?.invalidCaptcha) {
            {{ 'captcha.invalid' | translate }}
          }
        </div>
      } @else if (captcha.touched && captcha?.valid) {
        <div id="captcha-success" class="alert alert-success captcha-warning cbw-captcha-success" role="status">
          {{ 'captcha.valid' | translate }}
        </div>
      }
    </div>
  </div>
}

@if (friendlyCaptchaRenewal()) {
  <!-- A refused booking spent the captcha answer; the next submit needs a fresh one. -->
  <div class="mb-2 cbsw-friendly-captcha-renewal">
    <p class="input-label cbw-captcha-label" id="friendly-captcha-renewal-hint">{{ friendlyCaptchaRenewalHintKey | translate }}</p>
    <div #friendlyCaptchaRenewal role="group" aria-labelledby="friendly-captcha-renewal-hint"></div>
  </div>
}

@if (showError) {
  <div class="alert alert-danger mt-3 mb-0" role="alert" [attr.aria-live]="'polite'">
    <div class="error-title" role="heading" aria-level="3">{{ errorTitle | translate }}</div>
    <div>{{ errorMessage }}</div>
  </div>
}

<div class="d-flex flex-column flex-md-row justify-content-md-between mt-4 mb-4" role="navigation" [attr.aria-label]="'Payment navigation'">
  <div>
    @if (bookingService.partnerData.is_cart_supported === 1) {
      <app-button
        id="{{ 'payment-method-book-additional-service-btn' }}"
        customClass="w-100"
        [isDisabled]="paymentLocked"
        (clickEvent)="bookAdditionalService()"
        [fontColor]="widgetService?.widgetConf?.button_font_color"
        [backgroundColor]="widgetService?.widgetConf?.button_background_color"
      >
        {{ 'booking_components.add_service' | translate }}
      </app-button>
    }
  </div>

  <div class="d-flex flex-column flex-md-row justify-content-md-end cbw-custom-navigation">
    <div class="me-md-2 my-2 my-md-0">
      <app-button
        id="{{ 'payment-method-previous-btn' }}"
        customClass="w-100"
        (clickEvent)="previous()"
        [isDisabled]="paymentLocked"
        [fontColor]="widgetService?.widgetConf?.button_font_color"
        [backgroundColor]="widgetService?.widgetConf?.button_background_color"
      >
        <span class="custom-button-icon back"></span>
        {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.SMART_WIDGET_SUMMERY_STEP_BACK_BUTTON_TEXT, type: 'template' }) | translation: 'template_content': lang )}}
      </app-button>
    </div>

    <div>
      <app-button
        id="{{ 'payment-method-book-btn' }}"
        customClass="w-100"
        (clickEvent)="submitBooking()"
        [isDisabled]="disableAllButton || isInvoiceAddressIncomplete || (paymentType === paymentMethods.ADYEN && adyenCheckoutLoading())"
        [fontColor]="widgetService?.widgetConf?.button_font_color"
        [backgroundColor]="widgetService?.widgetConf?.button_background_color"
      >
        <span
          [innerHTML]="((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_BOOK_BUTTON, type: 'template' }) | translation: 'template_content': lang)"
        ></span>
        @if (disableAllButton) {
          <span class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
        } @else {
          <span class="custom-button-icon next"></span>
        }
      </app-button>
    </div>
  </div>
</div>



